
import React from 'react';
import { Label } from '@/components/ui/label';
import { RadioGroup, RadioGroupItem } from '@/components/ui/radio-group';
import { Check, X } from 'lucide-react';

interface RadioGroupFieldProps {
  id: string;
  label: string;
  value: boolean | undefined;
  onChange: (value: boolean) => void;
}

const RadioGroupField = ({ id, label, value, onChange }: RadioGroupFieldProps) => {
  return (
    <div className="space-y-2">
      <Label htmlFor={id} className="text-sm font-medium">
        {label}
      </Label>
      
      <RadioGroup
        id={id}
        value={value === undefined ? undefined : value.toString()}
        onValueChange={(val) => onChange(val === "true")}
        className="flex items-center space-x-4"
      >
        <div className="flex items-center space-x-2">
          <RadioGroupItem 
            value="true" 
            id={`${id}-yes`}
            className="border-redflags-red text-redflags-red"
          />
          <Label 
            htmlFor={`${id}-yes`} 
            className="flex items-center space-x-1 cursor-pointer"
          >
            <span>Yes</span>
            <Check className="h-4 w-4 text-green-500" />
          </Label>
        </div>
        
        <div className="flex items-center space-x-2">
          <RadioGroupItem 
            value="false" 
            id={`${id}-no`}
            className="border-redflags-red text-redflags-red"
          />
          <Label 
            htmlFor={`${id}-no`} 
            className="flex items-center space-x-1 cursor-pointer"
          >
            <span>No</span>
            <X className="h-4 w-4 text-red-500" />
          </Label>
        </div>
      </RadioGroup>
    </div>
  );
};

export default RadioGroupField;
